import { makeStyles, Theme } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: Theme) => ({
  entry: {
    position: "relative",
    borderLeft: "2px solid #7f7f7f80",
    padding: "0 0 0 23px",
    display: "flex",
    flexDirection: "column",
    gap: 20,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      gap: 16,
      paddingLeft: 15
    }
  },
  entryHeader: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  },
  title: {
    color: "#2d2d2d"
  },
  removeButton: {
    position: "absolute",
    right: "-14px",
    "&.Mui-disabled": {
      color: "#eee"
    }
  }
}));
